import Vue from 'vue'

const CloudEditConfirmStreamInstance = Vue.extend(require('./cloudEditConfirmStream.vue').default);
let instance = null
let successPromise = null
let successResolve = null

let getInstance = () => {
  return new CloudEditConfirmStreamInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (successResolve) {
    successResolve(false)
    successResolve = null
  }
  successPromise = null
}

let CloudEditConfirmStream = (info) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  successPromise = new Promise((resolve, reject) => {
    successResolve = resolve
  })
  instance.open(info, successResolve)

  return successPromise
}

export default CloudEditConfirmStream
